import { default as certificateNZg3g8pzlxMeta } from "D:/tjtw/edu/education-web/pages/account/certificate.vue?macro=true";
import { default as collectLdRoAddq5TMeta } from "D:/tjtw/edu/education-web/pages/account/collect.vue?macro=true";
import { default as couponrt5yQYUToGMeta } from "D:/tjtw/edu/education-web/pages/account/coupon.vue?macro=true";
import { default as courseSlL1laRJcSMeta } from "D:/tjtw/edu/education-web/pages/account/course.vue?macro=true";
import { default as gradeYmc1q0YxdLMeta } from "D:/tjtw/edu/education-web/pages/account/grade.vue?macro=true";
import { default as infocktT5vKFkJMeta } from "D:/tjtw/edu/education-web/pages/account/info.vue?macro=true";
import { default as indexmbir2X6Q1JMeta } from "D:/tjtw/edu/education-web/pages/account/message/index.vue?macro=true";
import { default as note6xOM0JBwUeMeta } from "D:/tjtw/edu/education-web/pages/account/note.vue?macro=true";
import { default as indexn9jUgWDDlZMeta } from "D:/tjtw/edu/education-web/pages/account/order/index.vue?macro=true";
import { default as papermtcuGRpzyTMeta } from "D:/tjtw/edu/education-web/pages/account/paper.vue?macro=true";
import { default as listHrx9F7zy7OMeta } from "D:/tjtw/edu/education-web/pages/article/list.vue?macro=true";
import { default as viewLzKoM9NsNHMeta } from "D:/tjtw/edu/education-web/pages/article/view.vue?macro=true";
import { default as audiowq2Pyh5qNVMeta } from "D:/tjtw/edu/education-web/pages/course/audio.vue?macro=true";
import { default as combinekuBfcK24BcMeta } from "D:/tjtw/edu/education-web/pages/course/combine.vue?macro=true";
import { default as graphicpjRsGGV9aVMeta } from "D:/tjtw/edu/education-web/pages/course/graphic.vue?macro=true";
import { default as list9AUG1yR9B8Meta } from "D:/tjtw/edu/education-web/pages/course/list.vue?macro=true";
import { default as livemriEfvnKzLMeta } from "D:/tjtw/edu/education-web/pages/course/live.vue?macro=true";
import { default as single3NlFRy9yx7Meta } from "D:/tjtw/edu/education-web/pages/course/single.vue?macro=true";
import { default as subjectWzJu9aR1jmMeta } from "D:/tjtw/edu/education-web/pages/course/subject.vue?macro=true";
import { default as topiccBo8TsQpPwMeta } from "D:/tjtw/edu/education-web/pages/course/topic.vue?macro=true";
import { default as videoGn3zQNbzUEMeta } from "D:/tjtw/edu/education-web/pages/course/video.vue?macro=true";
import { default as analysisXoi6eocxieMeta } from "D:/tjtw/edu/education-web/pages/exam/analysis.vue?macro=true";
import { default as emigratedcJ7Kb17PPsMeta } from "D:/tjtw/edu/education-web/pages/exam/emigrated.vue?macro=true";
import { default as indexy0j1liSpDOMeta } from "D:/tjtw/edu/education-web/pages/exam/index.vue?macro=true";
import { default as list9xkqNgOJswMeta } from "D:/tjtw/edu/education-web/pages/exam/list.vue?macro=true";
import { default as resultf4F2LwwaoBMeta } from "D:/tjtw/edu/education-web/pages/exam/result.vue?macro=true";
import { default as startExameK0GZaGIuUMeta } from "D:/tjtw/edu/education-web/pages/exam/startExam.vue?macro=true";
import { default as homeworkx9rpmL1MJlMeta } from "D:/tjtw/edu/education-web/pages/grade/homework.vue?macro=true";
import { default as listtkJY2lebXhMeta } from "D:/tjtw/edu/education-web/pages/grade/list.vue?macro=true";
import { default as practicepzVhP7EcUaMeta } from "D:/tjtw/edu/education-web/pages/grade/practice.vue?macro=true";
import { default as viewHgl65LRftDMeta } from "D:/tjtw/edu/education-web/pages/grade/view.vue?macro=true";
import { default as indexCc7eWxJGUhMeta } from "D:/tjtw/edu/education-web/pages/index.vue?macro=true";
import { default as agreementSsT6UVRM31Meta } from "D:/tjtw/edu/education-web/pages/login/agreement.vue?macro=true";
import { default as indexhDZtGvLF04Meta } from "D:/tjtw/edu/education-web/pages/login/index.vue?macro=true";
import { default as emigratedON5fbGhYQyMeta } from "D:/tjtw/edu/education-web/pages/paper/emigrated.vue?macro=true";
import { default as indexYZnGFi82ZvMeta } from "D:/tjtw/edu/education-web/pages/paper/index.vue?macro=true";
import { default as listxpvvUYR4MHMeta } from "D:/tjtw/edu/education-web/pages/paper/list.vue?macro=true";
import { default as view9Kne1F8Js4Meta } from "D:/tjtw/edu/education-web/pages/paper/view.vue?macro=true";
import { default as buyXkAo6EiOw6Meta } from "D:/tjtw/edu/education-web/pages/pay/buy.vue?macro=true";
import { default as paySuccessf28yoHKy6mMeta } from "D:/tjtw/edu/education-web/pages/pay/paySuccess.vue?macro=true";
import { default as analysisL3J2xksA0mMeta } from "D:/tjtw/edu/education-web/pages/practice/analysis.vue?macro=true";
import { default as dailynP6clIEXfmMeta } from "D:/tjtw/edu/education-web/pages/practice/daily.vue?macro=true";
import { default as dailyProblemzJxKGM36mKMeta } from "D:/tjtw/edu/education-web/pages/practice/dailyProblem.vue?macro=true";
import { default as errorCcSbhqoWKQMeta } from "D:/tjtw/edu/education-web/pages/practice/error.vue?macro=true";
import { default as errorAnalysisDtjr7CX4kXMeta } from "D:/tjtw/edu/education-web/pages/practice/errorAnalysis.vue?macro=true";
import { default as errorProblemqf32Qd15rzMeta } from "D:/tjtw/edu/education-web/pages/practice/errorProblem.vue?macro=true";
import { default as errorResulto4y4JBOFoDMeta } from "D:/tjtw/edu/education-web/pages/practice/errorResult.vue?macro=true";
import { default as resultIHGdlEPbXeMeta } from "D:/tjtw/edu/education-web/pages/practice/result.vue?macro=true";
import { default as startPractice5oEubRzfbWMeta } from "D:/tjtw/edu/education-web/pages/practice/startPractice.vue?macro=true";
import { default as viewxyqOY2xVGBMeta } from "D:/tjtw/edu/education-web/pages/practice/view.vue?macro=true";
import { default as indexVnHDAnJnm6Meta } from "D:/tjtw/edu/education-web/pages/register/index.vue?macro=true";
import { default as indexIjMQCCXbSIMeta } from "D:/tjtw/edu/education-web/pages/resetpwd/index.vue?macro=true";
import { default as indexgrCbZuuxLVMeta } from "D:/tjtw/edu/education-web/pages/search/index.vue?macro=true";
import { default as listYCfVUlSHibMeta } from "D:/tjtw/edu/education-web/pages/teacher/list.vue?macro=true";
import { default as viewT0cbYQ8DcrMeta } from "D:/tjtw/edu/education-web/pages/teacher/view.vue?macro=true";
import { default as index1Hm2kCREi1Meta } from "D:/tjtw/edu/education-web/pages/vip/index.vue?macro=true";
import { default as successAzkr5zXSEmMeta } from "D:/tjtw/edu/education-web/pages/wx/success.vue?macro=true";
import { default as wxLAGIvfjH4yMeta } from "D:/tjtw/edu/education-web/pages/wx/wx.vue?macro=true";
export default [
  {
    name: certificateNZg3g8pzlxMeta?.name ?? "account-certificate",
    path: certificateNZg3g8pzlxMeta?.path ?? "/account/certificate",
    meta: certificateNZg3g8pzlxMeta || {},
    alias: certificateNZg3g8pzlxMeta?.alias || [],
    redirect: certificateNZg3g8pzlxMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/certificate.vue").then(m => m.default || m)
  },
  {
    name: collectLdRoAddq5TMeta?.name ?? "account-collect",
    path: collectLdRoAddq5TMeta?.path ?? "/account/collect",
    meta: collectLdRoAddq5TMeta || {},
    alias: collectLdRoAddq5TMeta?.alias || [],
    redirect: collectLdRoAddq5TMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/collect.vue").then(m => m.default || m)
  },
  {
    name: couponrt5yQYUToGMeta?.name ?? "account-coupon",
    path: couponrt5yQYUToGMeta?.path ?? "/account/coupon",
    meta: couponrt5yQYUToGMeta || {},
    alias: couponrt5yQYUToGMeta?.alias || [],
    redirect: couponrt5yQYUToGMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/coupon.vue").then(m => m.default || m)
  },
  {
    name: courseSlL1laRJcSMeta?.name ?? "account-course",
    path: courseSlL1laRJcSMeta?.path ?? "/account/course",
    meta: courseSlL1laRJcSMeta || {},
    alias: courseSlL1laRJcSMeta?.alias || [],
    redirect: courseSlL1laRJcSMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/course.vue").then(m => m.default || m)
  },
  {
    name: gradeYmc1q0YxdLMeta?.name ?? "account-grade",
    path: gradeYmc1q0YxdLMeta?.path ?? "/account/grade",
    meta: gradeYmc1q0YxdLMeta || {},
    alias: gradeYmc1q0YxdLMeta?.alias || [],
    redirect: gradeYmc1q0YxdLMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/grade.vue").then(m => m.default || m)
  },
  {
    name: infocktT5vKFkJMeta?.name ?? "account-info",
    path: infocktT5vKFkJMeta?.path ?? "/account/info",
    meta: infocktT5vKFkJMeta || {},
    alias: infocktT5vKFkJMeta?.alias || [],
    redirect: infocktT5vKFkJMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/info.vue").then(m => m.default || m)
  },
  {
    name: indexmbir2X6Q1JMeta?.name ?? "account-message",
    path: indexmbir2X6Q1JMeta?.path ?? "/account/message",
    meta: indexmbir2X6Q1JMeta || {},
    alias: indexmbir2X6Q1JMeta?.alias || [],
    redirect: indexmbir2X6Q1JMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/message/index.vue").then(m => m.default || m)
  },
  {
    name: note6xOM0JBwUeMeta?.name ?? "account-note",
    path: note6xOM0JBwUeMeta?.path ?? "/account/note",
    meta: note6xOM0JBwUeMeta || {},
    alias: note6xOM0JBwUeMeta?.alias || [],
    redirect: note6xOM0JBwUeMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/note.vue").then(m => m.default || m)
  },
  {
    name: indexn9jUgWDDlZMeta?.name ?? "account-order",
    path: indexn9jUgWDDlZMeta?.path ?? "/account/order",
    meta: indexn9jUgWDDlZMeta || {},
    alias: indexn9jUgWDDlZMeta?.alias || [],
    redirect: indexn9jUgWDDlZMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/order/index.vue").then(m => m.default || m)
  },
  {
    name: papermtcuGRpzyTMeta?.name ?? "account-paper",
    path: papermtcuGRpzyTMeta?.path ?? "/account/paper",
    meta: papermtcuGRpzyTMeta || {},
    alias: papermtcuGRpzyTMeta?.alias || [],
    redirect: papermtcuGRpzyTMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/account/paper.vue").then(m => m.default || m)
  },
  {
    name: listHrx9F7zy7OMeta?.name ?? "article-list",
    path: listHrx9F7zy7OMeta?.path ?? "/article/list",
    meta: listHrx9F7zy7OMeta || {},
    alias: listHrx9F7zy7OMeta?.alias || [],
    redirect: listHrx9F7zy7OMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/article/list.vue").then(m => m.default || m)
  },
  {
    name: viewLzKoM9NsNHMeta?.name ?? "article-view",
    path: viewLzKoM9NsNHMeta?.path ?? "/article/view",
    meta: viewLzKoM9NsNHMeta || {},
    alias: viewLzKoM9NsNHMeta?.alias || [],
    redirect: viewLzKoM9NsNHMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/article/view.vue").then(m => m.default || m)
  },
  {
    name: audiowq2Pyh5qNVMeta?.name ?? "course-audio",
    path: audiowq2Pyh5qNVMeta?.path ?? "/course/audio",
    meta: audiowq2Pyh5qNVMeta || {},
    alias: audiowq2Pyh5qNVMeta?.alias || [],
    redirect: audiowq2Pyh5qNVMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/audio.vue").then(m => m.default || m)
  },
  {
    name: combinekuBfcK24BcMeta?.name ?? "course-combine",
    path: combinekuBfcK24BcMeta?.path ?? "/course/combine",
    meta: combinekuBfcK24BcMeta || {},
    alias: combinekuBfcK24BcMeta?.alias || [],
    redirect: combinekuBfcK24BcMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/combine.vue").then(m => m.default || m)
  },
  {
    name: graphicpjRsGGV9aVMeta?.name ?? "course-graphic",
    path: graphicpjRsGGV9aVMeta?.path ?? "/course/graphic",
    meta: graphicpjRsGGV9aVMeta || {},
    alias: graphicpjRsGGV9aVMeta?.alias || [],
    redirect: graphicpjRsGGV9aVMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/graphic.vue").then(m => m.default || m)
  },
  {
    name: list9AUG1yR9B8Meta?.name ?? "course-list",
    path: list9AUG1yR9B8Meta?.path ?? "/course/list",
    meta: list9AUG1yR9B8Meta || {},
    alias: list9AUG1yR9B8Meta?.alias || [],
    redirect: list9AUG1yR9B8Meta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/list.vue").then(m => m.default || m)
  },
  {
    name: livemriEfvnKzLMeta?.name ?? "course-live",
    path: livemriEfvnKzLMeta?.path ?? "/course/live",
    meta: livemriEfvnKzLMeta || {},
    alias: livemriEfvnKzLMeta?.alias || [],
    redirect: livemriEfvnKzLMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/live.vue").then(m => m.default || m)
  },
  {
    name: single3NlFRy9yx7Meta?.name ?? "course-single",
    path: single3NlFRy9yx7Meta?.path ?? "/course/single",
    meta: single3NlFRy9yx7Meta || {},
    alias: single3NlFRy9yx7Meta?.alias || [],
    redirect: single3NlFRy9yx7Meta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/single.vue").then(m => m.default || m)
  },
  {
    name: subjectWzJu9aR1jmMeta?.name ?? "course-subject",
    path: subjectWzJu9aR1jmMeta?.path ?? "/course/subject",
    meta: subjectWzJu9aR1jmMeta || {},
    alias: subjectWzJu9aR1jmMeta?.alias || [],
    redirect: subjectWzJu9aR1jmMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/subject.vue").then(m => m.default || m)
  },
  {
    name: topiccBo8TsQpPwMeta?.name ?? "course-topic",
    path: topiccBo8TsQpPwMeta?.path ?? "/course/topic",
    meta: topiccBo8TsQpPwMeta || {},
    alias: topiccBo8TsQpPwMeta?.alias || [],
    redirect: topiccBo8TsQpPwMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/topic.vue").then(m => m.default || m)
  },
  {
    name: videoGn3zQNbzUEMeta?.name ?? "course-video",
    path: videoGn3zQNbzUEMeta?.path ?? "/course/video",
    meta: videoGn3zQNbzUEMeta || {},
    alias: videoGn3zQNbzUEMeta?.alias || [],
    redirect: videoGn3zQNbzUEMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/course/video.vue").then(m => m.default || m)
  },
  {
    name: analysisXoi6eocxieMeta?.name ?? "exam-analysis",
    path: analysisXoi6eocxieMeta?.path ?? "/exam/analysis",
    meta: analysisXoi6eocxieMeta || {},
    alias: analysisXoi6eocxieMeta?.alias || [],
    redirect: analysisXoi6eocxieMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/exam/analysis.vue").then(m => m.default || m)
  },
  {
    name: emigratedcJ7Kb17PPsMeta?.name ?? "exam-emigrated",
    path: emigratedcJ7Kb17PPsMeta?.path ?? "/exam/emigrated",
    meta: emigratedcJ7Kb17PPsMeta || {},
    alias: emigratedcJ7Kb17PPsMeta?.alias || [],
    redirect: emigratedcJ7Kb17PPsMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/exam/emigrated.vue").then(m => m.default || m)
  },
  {
    name: indexy0j1liSpDOMeta?.name ?? "exam",
    path: indexy0j1liSpDOMeta?.path ?? "/exam",
    meta: indexy0j1liSpDOMeta || {},
    alias: indexy0j1liSpDOMeta?.alias || [],
    redirect: indexy0j1liSpDOMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/exam/index.vue").then(m => m.default || m)
  },
  {
    name: list9xkqNgOJswMeta?.name ?? "exam-list",
    path: list9xkqNgOJswMeta?.path ?? "/exam/list",
    meta: list9xkqNgOJswMeta || {},
    alias: list9xkqNgOJswMeta?.alias || [],
    redirect: list9xkqNgOJswMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/exam/list.vue").then(m => m.default || m)
  },
  {
    name: resultf4F2LwwaoBMeta?.name ?? "exam-result",
    path: resultf4F2LwwaoBMeta?.path ?? "/exam/result",
    meta: resultf4F2LwwaoBMeta || {},
    alias: resultf4F2LwwaoBMeta?.alias || [],
    redirect: resultf4F2LwwaoBMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/exam/result.vue").then(m => m.default || m)
  },
  {
    name: startExameK0GZaGIuUMeta?.name ?? "exam-startExam",
    path: startExameK0GZaGIuUMeta?.path ?? "/exam/startExam",
    meta: startExameK0GZaGIuUMeta || {},
    alias: startExameK0GZaGIuUMeta?.alias || [],
    redirect: startExameK0GZaGIuUMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/exam/startExam.vue").then(m => m.default || m)
  },
  {
    name: homeworkx9rpmL1MJlMeta?.name ?? "grade-homework",
    path: homeworkx9rpmL1MJlMeta?.path ?? "/grade/homework",
    meta: homeworkx9rpmL1MJlMeta || {},
    alias: homeworkx9rpmL1MJlMeta?.alias || [],
    redirect: homeworkx9rpmL1MJlMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/grade/homework.vue").then(m => m.default || m)
  },
  {
    name: listtkJY2lebXhMeta?.name ?? "grade-list",
    path: listtkJY2lebXhMeta?.path ?? "/grade/list",
    meta: listtkJY2lebXhMeta || {},
    alias: listtkJY2lebXhMeta?.alias || [],
    redirect: listtkJY2lebXhMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/grade/list.vue").then(m => m.default || m)
  },
  {
    name: practicepzVhP7EcUaMeta?.name ?? "grade-practice",
    path: practicepzVhP7EcUaMeta?.path ?? "/grade/practice",
    meta: practicepzVhP7EcUaMeta || {},
    alias: practicepzVhP7EcUaMeta?.alias || [],
    redirect: practicepzVhP7EcUaMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/grade/practice.vue").then(m => m.default || m)
  },
  {
    name: viewHgl65LRftDMeta?.name ?? "grade-view",
    path: viewHgl65LRftDMeta?.path ?? "/grade/view",
    meta: viewHgl65LRftDMeta || {},
    alias: viewHgl65LRftDMeta?.alias || [],
    redirect: viewHgl65LRftDMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/grade/view.vue").then(m => m.default || m)
  },
  {
    name: indexCc7eWxJGUhMeta?.name ?? "index",
    path: indexCc7eWxJGUhMeta?.path ?? "/",
    meta: indexCc7eWxJGUhMeta || {},
    alias: indexCc7eWxJGUhMeta?.alias || [],
    redirect: indexCc7eWxJGUhMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: agreementSsT6UVRM31Meta?.name ?? "login-agreement",
    path: agreementSsT6UVRM31Meta?.path ?? "/login/agreement",
    meta: agreementSsT6UVRM31Meta || {},
    alias: agreementSsT6UVRM31Meta?.alias || [],
    redirect: agreementSsT6UVRM31Meta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/login/agreement.vue").then(m => m.default || m)
  },
  {
    name: indexhDZtGvLF04Meta?.name ?? "login",
    path: indexhDZtGvLF04Meta?.path ?? "/login",
    meta: indexhDZtGvLF04Meta || {},
    alias: indexhDZtGvLF04Meta?.alias || [],
    redirect: indexhDZtGvLF04Meta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: emigratedON5fbGhYQyMeta?.name ?? "paper-emigrated",
    path: emigratedON5fbGhYQyMeta?.path ?? "/paper/emigrated",
    meta: emigratedON5fbGhYQyMeta || {},
    alias: emigratedON5fbGhYQyMeta?.alias || [],
    redirect: emigratedON5fbGhYQyMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/paper/emigrated.vue").then(m => m.default || m)
  },
  {
    name: indexYZnGFi82ZvMeta?.name ?? "paper",
    path: indexYZnGFi82ZvMeta?.path ?? "/paper",
    meta: indexYZnGFi82ZvMeta || {},
    alias: indexYZnGFi82ZvMeta?.alias || [],
    redirect: indexYZnGFi82ZvMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/paper/index.vue").then(m => m.default || m)
  },
  {
    name: listxpvvUYR4MHMeta?.name ?? "paper-list",
    path: listxpvvUYR4MHMeta?.path ?? "/paper/list",
    meta: listxpvvUYR4MHMeta || {},
    alias: listxpvvUYR4MHMeta?.alias || [],
    redirect: listxpvvUYR4MHMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/paper/list.vue").then(m => m.default || m)
  },
  {
    name: view9Kne1F8Js4Meta?.name ?? "paper-view",
    path: view9Kne1F8Js4Meta?.path ?? "/paper/view",
    meta: view9Kne1F8Js4Meta || {},
    alias: view9Kne1F8Js4Meta?.alias || [],
    redirect: view9Kne1F8Js4Meta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/paper/view.vue").then(m => m.default || m)
  },
  {
    name: buyXkAo6EiOw6Meta?.name ?? "pay-buy",
    path: buyXkAo6EiOw6Meta?.path ?? "/pay/buy",
    meta: buyXkAo6EiOw6Meta || {},
    alias: buyXkAo6EiOw6Meta?.alias || [],
    redirect: buyXkAo6EiOw6Meta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/pay/buy.vue").then(m => m.default || m)
  },
  {
    name: paySuccessf28yoHKy6mMeta?.name ?? "pay-paySuccess",
    path: paySuccessf28yoHKy6mMeta?.path ?? "/pay/paySuccess",
    meta: paySuccessf28yoHKy6mMeta || {},
    alias: paySuccessf28yoHKy6mMeta?.alias || [],
    redirect: paySuccessf28yoHKy6mMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/pay/paySuccess.vue").then(m => m.default || m)
  },
  {
    name: analysisL3J2xksA0mMeta?.name ?? "practice-analysis",
    path: analysisL3J2xksA0mMeta?.path ?? "/practice/analysis",
    meta: analysisL3J2xksA0mMeta || {},
    alias: analysisL3J2xksA0mMeta?.alias || [],
    redirect: analysisL3J2xksA0mMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/analysis.vue").then(m => m.default || m)
  },
  {
    name: dailynP6clIEXfmMeta?.name ?? "practice-daily",
    path: dailynP6clIEXfmMeta?.path ?? "/practice/daily",
    meta: dailynP6clIEXfmMeta || {},
    alias: dailynP6clIEXfmMeta?.alias || [],
    redirect: dailynP6clIEXfmMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/daily.vue").then(m => m.default || m)
  },
  {
    name: dailyProblemzJxKGM36mKMeta?.name ?? "practice-dailyProblem",
    path: dailyProblemzJxKGM36mKMeta?.path ?? "/practice/dailyProblem",
    meta: dailyProblemzJxKGM36mKMeta || {},
    alias: dailyProblemzJxKGM36mKMeta?.alias || [],
    redirect: dailyProblemzJxKGM36mKMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/dailyProblem.vue").then(m => m.default || m)
  },
  {
    name: errorCcSbhqoWKQMeta?.name ?? "practice-error",
    path: errorCcSbhqoWKQMeta?.path ?? "/practice/error",
    meta: errorCcSbhqoWKQMeta || {},
    alias: errorCcSbhqoWKQMeta?.alias || [],
    redirect: errorCcSbhqoWKQMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/error.vue").then(m => m.default || m)
  },
  {
    name: errorAnalysisDtjr7CX4kXMeta?.name ?? "practice-errorAnalysis",
    path: errorAnalysisDtjr7CX4kXMeta?.path ?? "/practice/errorAnalysis",
    meta: errorAnalysisDtjr7CX4kXMeta || {},
    alias: errorAnalysisDtjr7CX4kXMeta?.alias || [],
    redirect: errorAnalysisDtjr7CX4kXMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/errorAnalysis.vue").then(m => m.default || m)
  },
  {
    name: errorProblemqf32Qd15rzMeta?.name ?? "practice-errorProblem",
    path: errorProblemqf32Qd15rzMeta?.path ?? "/practice/errorProblem",
    meta: errorProblemqf32Qd15rzMeta || {},
    alias: errorProblemqf32Qd15rzMeta?.alias || [],
    redirect: errorProblemqf32Qd15rzMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/errorProblem.vue").then(m => m.default || m)
  },
  {
    name: errorResulto4y4JBOFoDMeta?.name ?? "practice-errorResult",
    path: errorResulto4y4JBOFoDMeta?.path ?? "/practice/errorResult",
    meta: errorResulto4y4JBOFoDMeta || {},
    alias: errorResulto4y4JBOFoDMeta?.alias || [],
    redirect: errorResulto4y4JBOFoDMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/errorResult.vue").then(m => m.default || m)
  },
  {
    name: resultIHGdlEPbXeMeta?.name ?? "practice-result",
    path: resultIHGdlEPbXeMeta?.path ?? "/practice/result",
    meta: resultIHGdlEPbXeMeta || {},
    alias: resultIHGdlEPbXeMeta?.alias || [],
    redirect: resultIHGdlEPbXeMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/result.vue").then(m => m.default || m)
  },
  {
    name: startPractice5oEubRzfbWMeta?.name ?? "practice-startPractice",
    path: startPractice5oEubRzfbWMeta?.path ?? "/practice/startPractice",
    meta: startPractice5oEubRzfbWMeta || {},
    alias: startPractice5oEubRzfbWMeta?.alias || [],
    redirect: startPractice5oEubRzfbWMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/startPractice.vue").then(m => m.default || m)
  },
  {
    name: viewxyqOY2xVGBMeta?.name ?? "practice-view",
    path: viewxyqOY2xVGBMeta?.path ?? "/practice/view",
    meta: viewxyqOY2xVGBMeta || {},
    alias: viewxyqOY2xVGBMeta?.alias || [],
    redirect: viewxyqOY2xVGBMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/practice/view.vue").then(m => m.default || m)
  },
  {
    name: indexVnHDAnJnm6Meta?.name ?? "register",
    path: indexVnHDAnJnm6Meta?.path ?? "/register",
    meta: indexVnHDAnJnm6Meta || {},
    alias: indexVnHDAnJnm6Meta?.alias || [],
    redirect: indexVnHDAnJnm6Meta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/register/index.vue").then(m => m.default || m)
  },
  {
    name: indexIjMQCCXbSIMeta?.name ?? "resetpwd",
    path: indexIjMQCCXbSIMeta?.path ?? "/resetpwd",
    meta: indexIjMQCCXbSIMeta || {},
    alias: indexIjMQCCXbSIMeta?.alias || [],
    redirect: indexIjMQCCXbSIMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/resetpwd/index.vue").then(m => m.default || m)
  },
  {
    name: indexgrCbZuuxLVMeta?.name ?? "search",
    path: indexgrCbZuuxLVMeta?.path ?? "/search",
    meta: indexgrCbZuuxLVMeta || {},
    alias: indexgrCbZuuxLVMeta?.alias || [],
    redirect: indexgrCbZuuxLVMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: listYCfVUlSHibMeta?.name ?? "teacher-list",
    path: listYCfVUlSHibMeta?.path ?? "/teacher/list",
    meta: listYCfVUlSHibMeta || {},
    alias: listYCfVUlSHibMeta?.alias || [],
    redirect: listYCfVUlSHibMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/teacher/list.vue").then(m => m.default || m)
  },
  {
    name: viewT0cbYQ8DcrMeta?.name ?? "teacher-view",
    path: viewT0cbYQ8DcrMeta?.path ?? "/teacher/view",
    meta: viewT0cbYQ8DcrMeta || {},
    alias: viewT0cbYQ8DcrMeta?.alias || [],
    redirect: viewT0cbYQ8DcrMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/teacher/view.vue").then(m => m.default || m)
  },
  {
    name: index1Hm2kCREi1Meta?.name ?? "vip",
    path: index1Hm2kCREi1Meta?.path ?? "/vip",
    meta: index1Hm2kCREi1Meta || {},
    alias: index1Hm2kCREi1Meta?.alias || [],
    redirect: index1Hm2kCREi1Meta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/vip/index.vue").then(m => m.default || m)
  },
  {
    name: successAzkr5zXSEmMeta?.name ?? "wx-success",
    path: successAzkr5zXSEmMeta?.path ?? "/wx/success",
    meta: successAzkr5zXSEmMeta || {},
    alias: successAzkr5zXSEmMeta?.alias || [],
    redirect: successAzkr5zXSEmMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/wx/success.vue").then(m => m.default || m)
  },
  {
    name: wxLAGIvfjH4yMeta?.name ?? "wx-wx",
    path: wxLAGIvfjH4yMeta?.path ?? "/wx/wx",
    meta: wxLAGIvfjH4yMeta || {},
    alias: wxLAGIvfjH4yMeta?.alias || [],
    redirect: wxLAGIvfjH4yMeta?.redirect || undefined,
    component: () => import("D:/tjtw/edu/education-web/pages/wx/wx.vue").then(m => m.default || m)
  }
]